import React, { useState, useEffect } from "react";
import { testimonials } from "../data/data";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";

const Testimonials = () => {
  const [currentTestimonial, setCurrentTestimonial] = useState(0);

  const nextTestimonial = () => {
    setCurrentTestimonial((prev) =>
      prev === testimonials.length - 1 ? 0 : prev + 1
    );
  };

  const prevTestimonial = () => {
    setCurrentTestimonial((prev) =>
      prev === 0 ? testimonials.length - 1 : prev - 1
    );
  };

  // ✅ Auto slide every 3 seconds
  useEffect(() => {
    const interval = setInterval(() => {
      nextTestimonial();
    }, 3000);

    return () => clearInterval(interval);
  }, [currentTestimonial]);

  return (
    <section className="py-10 md:py-12 relative overflow-hidden">
      {/* Decorative Elements */}
      <div className="absolute top-0 right-0 w-96 h-96 bg-gold/30 rounded-full -translate-y-1/2 translate-x-1/2 opacity-50"></div>
      <div className="absolute bottom-0 left-0 w-64 h-64 bg-gold/30 rounded-full translate-y-1/3 -translate-x-1/3 opacity-40"></div>

      <div className="container mx-auto px-4 md:px-6 relative z-10">
        <div className="text-center max-w-md mx-auto mb-12 md:mb-16">
          <h2 className="text-3xl md:text-4xl font-bold text-gold mb-4">
            Look at what people say about us
          </h2>
          <p className="text-gray-400 text-lg">
            Check out our reviews! Let the people tell you the opportunities we
            provide!
          </p>
        </div>

        <div className="max-w-4xl mx-auto">
          <div className="relative ">
            {/* Current Testimonial */}
            <div className="bg-slate-900/60 rounded-xl shadow-xl p-8 md:p-10 h-[540px] md:h-[320px] overflow-hidden">
              <div className="flex flex-col md:flex-row gap-8 items-center">
                <div className="md:w-1/3">
                  <div className="w-24 h-24 md:w-32 md:h-32 rounded-full overflow-hidden mx-auto border-4 border-blue-100">
                    <img
                      src={testimonials[currentTestimonial].image}
                      alt={testimonials[currentTestimonial].name}
                      className="w-full h-full object-cover"
                    />
                  </div>
                </div>

                <div className="md:w-2/3 text-center md:text-left">
                  <Quote
                    size={40}
                    className="text-blue-100 mb-4 mx-auto md:mx-0"
                  />
                  <p className="text-lg font-semibold italic mb-2">
                    "{testimonials[currentTestimonial].quote}"
                  </p>
                  <p className="text-gray-400 text-base italic mb-2">
                    {testimonials[currentTestimonial].description}
                  </p>
                  <div>
                    <p className="font-bold text-xl">
                      {testimonials[currentTestimonial].name}
                    </p>
                    <p className="text-gray-400">
                      {testimonials[currentTestimonial].role}
                    </p>
                  </div>
                </div>
              </div>
            </div>

            {/* Navigation Buttons */}
            <button
              onClick={prevTestimonial}
              className="absolute -left-4 md:-left-6 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md text-gray-800 hover:text-blue-600 focus:outline-none"
            >
              <ChevronLeft size={20} />
            </button>
            <button
              onClick={nextTestimonial}
              className="absolute -right-4 md:-right-6 top-1/2 transform -translate-y-1/2 bg-white p-3 rounded-full shadow-md text-gray-800 hover:text-blue-600 focus:outline-none"
            >
              <ChevronRight size={20} />
            </button>
          </div>

          {/* Indicators */}
          <div className="flex justify-center mt-8 space-x-2">
            {testimonials.map((_, index) => (
              <button
                key={index}
                onClick={() => setCurrentTestimonial(index)}
                className={`w-3 h-3 rounded-full transition-all ${currentTestimonial === index ? "bg-gold w-6" : "bg-gray-800"
                  }`}
                aria-label={`Go to testimonial ${index + 1}`}
              />
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
